import api from '@pray/shared/utils/api';

import type { ContentTag } from './getContentTags';

export interface AddContentTagResponse {
  data: ContentTag[];
}

export interface AddContentTagParams {
  artistId: string;
  contentId: string;
  tagId?: string;
  tagName?: string;
  color?: string;
}

/**
 * Add a tag to a content item
 * Can add an existing tag by ID or create a new tag by name
 */
export async function addContentTag({
  artistId,
  contentId,
  tagId,
  tagName,
  color,
}: AddContentTagParams): Promise<AddContentTagResponse> {
  const body: Record<string, string> = {};

  if (tagId) {
    body.tag_id = tagId;
  }
  if (tagName) {
    body.tag_name = tagName;
  }
  if (color) {
    body.color = color;
  }

  const url = `/web/studio/artists/${artistId}/content/${contentId}/tags`;
  const response = await api.executePostRequest<AddContentTagResponse>(url, body);
  return response.data;
}
